<template>
  <router-view></router-view>
</template>
<script>
export default {
    name: `InstrumentManagement`,
    props: {

    },
    data() {
        return {
            title: `器械管理`
        }
    },
    computed: {

    },
    created() {
    },
    methods: {

    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Instrument/Index.vue